const ACTION_MOUSE_CLICK_RIGHT = 1;
const ACTION_MOUSE_MOVE = 2;
const ACTION_MOUSE_DOWN_RIGHT = 3;
const ACTION_MOUSE_UP_RIGHT = 4;
const ACTION_MOUSE_CLICK_LEFT = 5;
const ACTION_MOUSE_DOWN_LEFT = 6;
const ACTION_MOUSE_UP_LEFT = 7;


export {
    ACTION_MOUSE_MOVE,
    ACTION_MOUSE_CLICK_RIGHT,
    ACTION_MOUSE_DOWN_RIGHT,
    ACTION_MOUSE_UP_RIGHT,
    ACTION_MOUSE_CLICK_LEFT,
    ACTION_MOUSE_DOWN_LEFT,
    ACTION_MOUSE_UP_LEFT
};